define([
	"csi/def",
	"csi/def/ActionFactory",
	"csi/image/_base",
	"./ActionImage"
], function(def,ActionFactory,image,ActionImage) {

	return ActionFactory.declare("imageRight", ActionImage, {
		constructor: function(xml) {
			this.m_id = "PropertyImageRight";
			this.m_class = "iconImageRight";
			this.m_typeControl = def.ACTION_ICON;
		},

		hasAccess: function(/*def.Context*/ctx) {
			// summary: determine if selected image can move left
			var	key = ctx.view.getCurrentImageKey();
			var	keyLast = image.getLastKey(this.getImageValue(ctx.getNode()));
			return key && (key != keyLast) && this.inherited(arguments);
		}
	});
});